import { render, staticRenderFns } from "./TabelaGeral.vue?vue&type=template&id=49349e04"
import script from "./TabelaGeral.vue?vue&type=script&lang=js"
export * from "./TabelaGeral.vue?vue&type=script&lang=js"
import style0 from "./TabelaGeral.vue?vue&type=style&index=0&id=49349e04&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports